import React from 'react'
import { components, constants, useTranslation, useServices } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import ManifestKeys from 'src/constants/locale/key/AciHighwayManifest'
import Box from '@material-ui/core/Box'
import AciHighwayManifestApiUrls from 'src/apiUrls/AciHighwayManifestApiUrls'
import EmailCoverSheetFormProperties from './EmailCoverSheetFormProperties'
import { FileForUserGetCurrentLoginId } from 'src/common/FileForUserCommon'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  button: { CngButton },
  form: {
   CngForm
  },
  CngDialog,
} = components

const { FormState } = constants

function EmailCoverSheetDialog(props) {
  const {
    openDialog,
    onClose,
    showNotification
  } = props

  const { initialValues, makeValidationSchema } = EmailCoverSheetFormProperties.formikProps
  const {securedSendRequest } = useServices()
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()   

  function handleEmailCoverSheet(data){
    try {
      securedSendRequest.execute(
        'POST',
        AciHighwayManifestApiUrls.EMAIL_COVERSHEET,
        data,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (!errorMessages) {
                showNotification(
                  'success',
                  aciHighwayManifestTranslationText.emailCoversheetSuccess
                )
                onClose()
              } else {
                errorMessages.forEach((message) =>
                  showNotification('error', message)
                )
              }
            }
          }
        },
        () => {
          showNotification(aciHighwayManifestTranslationText.error, aciHighwayManifestTranslationText.emailCoversheetError)
        }
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          formikProps={{
            initialValues: {
              ...(initialValues)
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
                data.tripNo = openDialog.data && openDialog.data.tripNum
                data.partyId = openDialog.data && openDialog.data.partyId
              data.userId = FileForUserGetCurrentLoginId()
                handleEmailCoverSheet(data)
                onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <EmailCoverSheetFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
              tripNo={openDialog.data && openDialog.data.tripNum}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {aciHighwayManifestTranslationText.sendButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={aciHighwayManifestTranslationText.emailCoverSheet}
      // fullWidth
      // maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={openDialog.open}
      shouldShowCloseButton
    />
  )
}

export default EmailCoverSheetDialog
